var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-body', [_c('b-card-title', {
    staticClass: "mb-2 px-6 pt-6"
  }, [_c('div', [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "cart-fill",
      "variant": "primary"
    }
  }), _c('span', [_vm._v("Vendas")])], 1), _c('FiltroPeriodo', {
    staticClass: "mt-4",
    attrs: {
      "value": _vm.periodo,
      "default-label": "Hoje",
      "auto-apply-on-mount": !_vm.ignoreInitialApply
    },
    on: {
      "apply": _vm.onApplyPeriodo
    }
  })], 1), _c('div', {
    staticClass: "pl-6 pb-4"
  }, [_vm.loading ? _c('div', {
    staticClass: "display-4"
  }, [_c('b-skeleton', {
    attrs: {
      "width": "40%",
      "height": "36px"
    }
  })], 1) : _c('div', [_c('h2', {
    staticClass: "display-4 text-primary mb-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.vendasNumber)) + " ")])])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };